import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  InputGroup,
  NonIdealState,
  Popover,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { newEmpresa } from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { CentralStore } from "../../stores/erros/CentralStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import { formatCnpj } from "../../utils";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import SimplesNacional from "./simples";
const Calculo = React.lazy(() => import("./calculo"));
const Conta = React.lazy(() => import("./conta"));
const Sitifs = React.lazy(() => import("./sitfis"));
const Cnds = React.lazy(() => import("./cnds"));
const Empresa = React.lazy(() => import("./empresas"));
const PgdasBI = React.lazy(() => import("./pgdas"));
const Parcelamentos = React.lazy(() => import("./parcelamentos"));

const InputMask = require("react-input-mask");

interface State {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class CentralAcoesPage extends React.Component<{}, State> {

  obs = observable({
    modalNotify: false as boolean,
    celular: "" as string,
    chat_id: "" as string,
    email: "" as string,
    periodicidade: "" as string,
    horario: "" as string,
    dia: "" as string,
    meio: "" as string,
    selectedTab: "calculo" as string,
    selectedPeriod: [] as any,
    listEmpresas: [] as any[],
    periodo_selecionado: ""

  })

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Central de Ações");
  }

  async componentDidMount() {
    await CentralStore.loadNotificacao()
    await CentralStore.load();
    this.obs.selectedPeriod = AppStore.obs1.selectedPeriod;
    this.handleDateChange(this.obs.selectedPeriod);

    ResultadoStore.obs.results = [];
    AppStore.setSelectedEmpresa(newEmpresa());
    ResultadoStore.clearAllData();
    ResultadoStore.obs.icmsNomeSelect = "";
  }

  handleCloseModal = () => {

    this.obs.modalNotify = false;

    CentralStore.obs.notificacoes_configuradas = null;

  };

  handleRemoveNotificacoes(id: any) {
    CentralStore.deleteNotificacoes(id);
  }

  refresh = () => {
    window.location.reload();
  };

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    this.setState({ date: val });
    this.obs.selectedPeriod = val;
  };

  createNotify = async () => {

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (this.obs.meio == "") {
      toast.error('Preencha o meio de comunicação', {});
      return;
    }

    if (this.obs.meio == "E-mail") {

      if (this.obs.email == "") {
        toast.error('Preencha o email', {});
        return;
      }

      if (!regex.test(this.obs.email)) {
        toast.error("E-mail inválido!", {});
        return;
      }

      this.obs.celular = ""
      this.obs.chat_id = ""

    }

    if (this.obs.meio == "SMS") {

      if (this.obs.celular == "") {
        toast.error('Preencha o celular', {});
        return;
      }

      this.obs.email = ""
      this.obs.chat_id = ""

    }

    if (this.obs.meio == "Telegram") {

      if (this.obs.chat_id == "") {
        toast.error('Preencha o Chat Id', {});
        return;
      }

      this.obs.email = ""
      this.obs.celular = ""

    }

    if (this.obs.listEmpresas.length == 0) {
      toast.error('Selecione pelo menos uma Empresa', {});
      return;
    }

    if (this.obs.periodo_selecionado == "") {
      toast.error('Selecione a periodicidade', {});
      return;
    }

    if (this.obs.periodo_selecionado == "2" && this.obs.dia == "") {
      toast.error('Selecione o Dia da Semana', {});
      return;
    }

    if (this.obs.periodo_selecionado != "2") {
      this.obs.dia = ""
    }


    this.obs.modalNotify = false;

    await CentralStore.createNotificacao(this.obs.meio, this.obs.celular, this.obs.email, this.obs.periodo_selecionado, this.obs.dia, this.obs.listEmpresas, this.obs.chat_id);

    CentralStore.loadNotificacao();

    this.obs.listEmpresas = []

  };

  handleNotify = async () => {

    await CentralStore.buscaDadosNotificacao();

    if (CentralStore.obs.notificacoes_configuradas) {

      this.obs.chat_id = CentralStore.obs.notificacoes_configuradas.chat_id;

      this.obs.celular = CentralStore.obs.notificacoes_configuradas.celular;

      this.obs.email = CentralStore.obs.notificacoes_configuradas.email;

      this.obs.dia = CentralStore.obs.notificacoes_configuradas.dia;

      this.obs.meio = CentralStore.obs.notificacoes_configuradas.meio_comunicacao;

      this.obs.listEmpresas = CentralStore.obs.notificacoes_configuradas.empresas;

      this.obs.periodo_selecionado = (CentralStore.obs.notificacoes_configuradas.periodicidade == "DIARIO") ? "1" : CentralStore.obs.notificacoes_configuradas.periodicidade ==  "SEMANAL" ? "2" : "3";

    }

    this.obs.modalNotify = true;

  };

  handleModalCreateNotify = () => {

    this.obs.modalNotify = true;

  };


  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.listEmpresas.push(row.cnpj_default);

    } else {

      let index = this.obs.listEmpresas.indexOf(row.cnpj_default);

      this.obs.listEmpresas.splice(index, 1);
    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      this.obs.listEmpresas = row?.map(value => {
        return value.cnpj_default;
      });

    } else {

      this.obs.listEmpresas = [];

    }

  };

  renderData() {

    let select_empresas = EmpresaStore.sortedEmpresas?.map(map_emp => {
      let emp = EmpresaStore.getByCnpj(map_emp.cnpj);
      if (emp) {
        if (emp.ativo) {
          return ({
            _id: emp._id,
            razao_social: emp.razao_social,
            cnpj: formatCnpj(emp.cnpj),
            cnpj_default: emp.cnpj
          })
        }
      }
    });

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.listEmpresas,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const formatEmpresa = (cell, row) => {

      return `${row.razao_social} - (${row.cnpj})`

    }

    return (
      <React.Suspense fallback={<div>Carregando gráficos…</div>}>
      <div className="empresas-page">

        <Dialog
          isOpen={this.obs.modalNotify}
          onClose={this.handleCloseModal}
          title="Notificar-me"
          className="modalErrosDown"
        >
          <div className={Classes.DIALOG_BODY}>
            <div>
              <MDBRow>
                <MDBCol md="6">
                  <h3 className="titleProccess">Gostaria de ser alertado quando algo estiver errado?</h3>
                  <p>Configure uma notificação para quando você tiver alguma <b>pendência</b>.</p>

                  <br />

                  <FormGroup label="Selecione o meio de comunicação">
                    <select
                      onChange={(e) => this.obs.meio = e.target.value}
                      defaultValue={this.obs.meio}
                      className="bp3-button bp3-align-left"
                    >
                      <option value="#">Selecione uma opção</option>
                      <option value="E-mail">E-mail</option>
                      <option value="SMS">SMS</option>
                      <option value="Telegram">Telegram</option>
                    </select>
                  </FormGroup>

                  {this.obs.meio == "SMS" &&
                    <FormGroup
                      label="Celular"
                      labelFor="celular"
                    >
                      <InputMask
                        mask="(99) 99999-9999"
                        className="bp3-input"
                        style={{ width: "100%" }}
                        defaultValue={this.obs.celular}
                        onChange={(e: any) => this.obs.celular = e.target.value}
                      />
                    </FormGroup>
                  }
                  {this.obs.meio == "Telegram" &&
                    <FormGroup
                      label="Telegram"
                      labelFor="telegram"
                    >
                      <InputGroup
                        id="telegram"
                        defaultValue={this.obs.chat_id}
                        onChange={(e: any) => this.obs.chat_id = e.target.value}
                      />
                    </FormGroup>
                  }
                  {this.obs.meio == "E-mail" &&
                    <FormGroup
                      label="E-mail"
                      labelFor="email"
                    >
                      <InputGroup
                        id="email"
                        defaultValue={this.obs.email}
                        onChange={(e: any) => this.obs.email = e.target.value}
                      />
                    </FormGroup>
                  }

                  <FormGroup
                    label={`Período de comunicação`}
                  >
                    <select
                      onChange={(e) => this.obs.periodo_selecionado = e.target.value}
                      value={this.obs.periodo_selecionado}
                      className="bp3-button bp3-align-left"
                    >
                      <option value="">Selecione uma opção</option>
                      <option value={"1"}>Diário</option>
                      <option value={"2"}>Semanal</option>
                      <option value={"3"}>Mensal</option>
                    </select>
                  </FormGroup>

                  {this.obs.periodo_selecionado == "2" &&
                    (
                      <FormGroup
                        label="Selecione dia"
                      >
                        <select
                          onChange={(e) => this.obs.dia = e.target.value}
                          value={this.obs.dia}
                          className="bp3-button bp3-align-left"
                        >
                          <option value="">Selecione uma opção</option>
                          <option value={"7"}>Domingo</option>
                          <option value={"1"}>Segunda-feira</option>
                          <option value={"2"}>Terça-feira</option>
                          <option value={"3"}>Quarta-feira</option>
                          <option value={"4"}>Quinta-feira</option>
                          <option value={"5"}>Sexta-feira</option>
                          <option value={"6"}>Sábado</option>
                        </select>
                      </FormGroup>
                    )}
                </MDBCol>

                <MDBCol md="6">
                  <FormGroup
                    label="Selecione as Empresas:"
                    labelFor="empresas"
                  >
                    <div className="select-empresa-notificacoes">
                      <BootstrapTable data={select_empresas} selectRow={selectRowProp}>
                        <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formatEmpresa} dataField="" width="95%">Empresa</TableHeaderColumn>
                      </BootstrapTable>
                    </div>
                  </FormGroup>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <div
                  className="nz-button-panel"
                  style={{ float: "right", width: "100%" }}
                >
                  <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                      {CentralStore.obs.isNotificacao &&
                        <Popover
                          popoverClassName={Classes.POPOVER_CONTENT_SIZING}
                        >
                          <Button intent="danger">Excluir Agendamento</Button>
                          <div>
                            <H5>Confirmar exclusão?</H5>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: 15,
                              }}
                            >
                              <Button
                                className={Classes.POPOVER_DISMISS}
                                style={{ marginRight: 10 }}
                              >
                                Cancelar
                              </Button>
                              <Button
                                onClick={() => {
                                  this.handleRemoveNotificacoes(CentralStore.obs.notificacoes_id);
                                }}
                                intent="danger"
                                className={Classes.POPOVER_DISMISS}
                              >
                                Excluir
                              </Button>
                            </div>
                          </div>
                        </Popover>
                      }
                      <Button onClick={this.handleCloseModal}>Cancelar</Button>
                      <Button intent="primary" onClick={this.createNotify}>
                        Salvar
                      </Button>
                    </div>
                  </div>
                </div>
              </MDBRow>

            </div>
          </div>
        </Dialog>

        <MDBRow>
          <MDBCol md="12">
            <span
              style={{ float: "right", cursor: "pointer" }}
              onClick={CentralStore.obs.isNotificacao
                ? (e) => this.handleNotify()
                : (e) => this.handleModalCreateNotify()}
            >
              <span>
                {CentralStore.obs.isNotificacao
                  ? <span className="estabilizado notificacao-central">Notificação Configurada</span>
                  : <span className="atencao notificacao-central">Notificar-me</span>
                }
              </span>
            </span>
          </MDBCol>
        </MDBRow>

        <Tabs
          id="tabs"
          className="tabsCalculos tabsCentral"
          selectedTabId={this.obs.selectedTab}
          onChange={(tabId) => this.obs.selectedTab = String(tabId)}
          renderActiveTabPanelOnly={true}
        >

          <Tab id="calculo" title="Cálculo" panel={<Calculo />} />
          <Tab id="conta" title="Conta" panel={<Conta />} />
          <Tab id="sitfis" title="Situação Fiscal (RFB)" panel={<Sitifs />} />
          <Tab id="cnds" title="Cnds" panel={<Cnds />} />
          <Tab id="empresa" title="Empresas" panel={<Empresa />} />
          <Tab id="simples" title={"Simples Nacional"} panel={<SimplesNacional />} />
          <Tab id="parcelamentos" title="Parcelamentos" panel={<Parcelamentos />} />
        </Tabs>

        <div style={{ marginBottom: 20 }} />

      </div>
      </React.Suspense>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("l1") == -1) {

      return this.renderNonIdeal();

    } else {

      return this.renderData();

    }
  }
}
